import React from 'react';
import ScoreCountDaily from '../../common/ScoreCountDaily';

const RatingRow = ({dayData}) => {

    if(!dayData.time){
        return <></>
    }

    // Backend omits rating_score entirely when the spot has no rating preferences set.
    if(!dayData.rating_score){
        return <></>
    }

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 pb-1 pt-2 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        Rating
                    </div>
                </div>
            </td>
            {dayData.time.map((value, index) => (
                <td key={index} className="pl-2 pb-1 pt-2 text-center">
                    <div className="inline-flex flex-col items-center gap-1">
                        <ScoreCountDaily score={dayData.rating_score[index]} />
                    </div>
                </td>
            ))}
        </tr>
    )
}

export default RatingRow;
